import { useState } from 'react'
import FormsyInput from '@components/Textfield/withFormsy'
import Select from '@components/Select/RequiredSelectWithFormsy'
import {
    countries,
    getStates,
    getStateValue,
    getCountryValue,
    CAPostalCodeRegex,
    CAPostalCodeRegexString,
} from 'shared/states'

import { withTranslate } from '@i18n/utils'
import { CURRENT_COUNTRY_CANADA } from 'shared/constants'

export const AddressFormCa = withTranslate(
    ({
        address1,
        address2,
        city,
        postalCode,
        addressee,
        state,
        country = window.COUNTRY_PURCHASE_FLOW,
        prefix = '',
        translate: t,
        withAddressee,
    }) => {
        const [selectedCountry, setSelectedCountry] = useState(country)
        const isCanada = selectedCountry === CURRENT_COUNTRY_CANADA

        return (
            <>
                {withAddressee && (
                    <div className="row">
                        <div className="col-md-6">
                            <FormsyInput
                                value={addressee}
                                name={`${prefix}.addressee`}
                                required
                                placeholder={t('dashboard.account.addressee')}
                                validationError={t('dashboard.account.addressee.invalid')}
                                autoComplete="name"
                            />
                        </div>
                    </div>
                )}
                <div className="row">
                    <div className="col-md-6">
                        <FormsyInput
                            name={`${prefix}.address1`}
                            value={address1}
                            placeholder={t('dashboard.account.address1')}
                            required
                            validationError={t('dashboard.account.address1.invalid')}
                            autoComplete="address-line1"
                        />
                    </div>
                    <div className="col-md-6">
                        <FormsyInput
                            name={`${prefix}.address2`}
                            value={address2}
                            placeholder={t('dashboard.account.address2')}
                            autoComplete="address-line2"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <FormsyInput
                            name={`${prefix}.postalCode`}
                            value={postalCode}
                            uppercase
                            placeholder={t('dashboard.account.postalCode')}
                            required
                            autoComplete="postal-code"
                            validationError={
                                isCanada
                                    ? t('dashboard.account.postalCode.ca.invalid')
                                    : t('dashboard.account.postalCode.invalid')
                            }
                            pattern={isCanada && CAPostalCodeRegexString}
                            validations={
                                isCanada && {
                                    matchRegexp: CAPostalCodeRegex,
                                }
                            }
                        />
                    </div>
                    <div className="col-md-6">
                        <FormsyInput
                            name={`${prefix}.city`}
                            value={city}
                            placeholder={t('dashboard.account.city')}
                            required
                            validationError={t('dashboard.account.city.invalid')}
                            autoComplete="address-level2"
                        />
                    </div>

                    <div className="col-md-6 form-group">
                        <Select
                            ariaLabel={t('dashboard.label.state.select')}
                            options={getStates(selectedCountry)}
                            isSearchable={true}
                            getSelectValue={getStateValue(selectedCountry)}
                            value={state}
                            name={`${prefix}.state`}
                            placeholder={t('dashboard.account.state')}
                            required
                        />
                    </div>

                    <div className="col-md-6 form-group">
                        <Select
                            ariaLabel={t('dashboard.label.country.select')}
                            options={countries}
                            onChange={setSelectedCountry}
                            isSearchable={true}
                            getSelectValue={getCountryValue}
                            value={selectedCountry}
                            name={`${prefix}.country`}
                            placeholder={t('dashboard.account.country')}
                            required
                        />
                    </div>
                </div>
            </>
        )
    }
)
